export default __webpack_public_path__ + "static/media/caution-sign.1344a8e7.png";